import { atom, useAtom } from "jotai";
import { type Address, getAddress } from "viem";

import { useMirrorAccount } from "#/store/app/devMode/mirrorAccount";

export const accountAtom = atom<Address>();

export const useAccount = () => {
  const [account, setAccount] = useAtom(accountAtom);
  const { mirrorAccount } = useMirrorAccount();
  const normalizedMirrorAccount = mirrorAccount
    ? getAddress(mirrorAccount)
    : undefined;
  const effectiveAccount = normalizedMirrorAccount || account;
  const isAccountConnected = Boolean(effectiveAccount);

  return {
    account: effectiveAccount,
    isAccountConnected,
    setAccount,
  };
};
